<div class="px-4 py-2 d-flex align-items-center gap-2">
  <h2 class="modal-title">
    {{ 'configurationCreation.mounting_rail.title.edit_rail_mode' | translate }}
  </h2>
</div>
<div class="mx-3 flex-grow-1 align-items-stretch">
  <app-mounting-rail
    #mountingRail
    [railArticleUsage]="railArticleUsage"
    [useComponentToSwitchRail]="true"/>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-forward btn-secondary btn-cancel" (click)="onFinish()">
    {{ 'global.label.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary btn-forward btn-forward component-action" (click)="nextStep()"
    [class.event-disabled]="!submitEnabled" [disabled]="!submitEnabled" id="projectnavigation-submit"
    data-testid="projectnavigation-submit">
    {{ 'global.label.accept' | translate }}
  </button>
</div>
